import { render, staticRenderFns } from "./WorksDetail.vue?vue&type=template&id=d45688e4&scoped=true&"
import script from "./WorksDetail.vue?vue&type=script&lang=js&"
export * from "./WorksDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorksDetail.vue?vue&type=style&index=0&id=d45688e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45688e4",
  null
  
)

export default component.exports